import { t } from '@avalara/bat-apps-shared/i18n';
import type { Content } from '../../../../../types';
import conf from '../../../conf';

export const content: Array<Content> = [
  {
    title: t('client.headings.review-developer-resources'),
    textContent:
      "Find comprehensive API references, including a detailed Developer Guide. With SDKs for all the major programming languages, you don't have to build your integration from the ground up.",
    buttonText: 'Get develop help',
    link: 'https://developer.avalara.com/',
  },
  {
    title: t('client.headings.keep-kicking-the-tires-on-the-avatax-api'),
    textContent:
      'Take our API for another spin. Test tax functions for multiple tax types, run test calculations for the places where you do business, and see how we integrate with ecommerce platforms and ERPs.',
    buttonText: 'Go to your AvaTax trial',
    link: conf.HOME_URL,
  },
  {
    title: t('client.headings.find-a-plan-that-fits-your-business'),
    textContent:
      'Connect seamlessly with your ERP, CRM, and billing systems so you can fix AvaTax into your checkout process. Chat with an Avalara representative to find a plan that fits your workflow.',
    buttonText: 'Speak with Sales',
    link: 'https://www.avalara.com/us/en/get-started.html',
  },
];
